module.exports = __webpack_public_path__ + "Step 3.912d1de5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/2018/landing/Step 3.png
// module id = Hked
// module chunks = 0